import React from "react"
import Seo from "../components/seo"
import NavigationBar from "../components/NavigationBar"
import Footer from "../components/Footer"
import CookiesModal from "../components/CookiesModal"
import CourseForm from "../components/forms/CourseForm"
import { Link, graphql } from "gatsby"

import "./CourseTemplate.scss"

const ProfileIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="15.525" viewBox="0 0 16 15.525"><path d="M168,282.5a3.6,3.6,0,1,1,2.7-1.05A3.655,3.655,0,0,1,168,282.5Zm-8,8.025v-2.35a2.751,2.751,0,0,1,.475-1.625,3.05,3.05,0,0,1,1.225-1.025,18.792,18.792,0,0,1,3.213-1.125,12.984,12.984,0,0,1,3.088-.375,12.439,12.439,0,0,1,3.075.388,20.921,20.921,0,0,1,3.2,1.117,3.018,3.018,0,0,1,1.255,1.024,2.744,2.744,0,0,1,.472,1.621v2.35Zm1.5-1.5h13v-.85a1.37,1.37,0,0,0-.238-.762,1.505,1.505,0,0,0-.587-.538,13.275,13.275,0,0,0-2.925-1.062,12.934,12.934,0,0,0-2.75-.288,13.286,13.286,0,0,0-2.775.288,12.7,12.7,0,0,0-2.925,1.062,1.5,1.5,0,0,0-.8,1.3ZM168,281a2.18,2.18,0,1,0-1.613-.637A2.185,2.185,0,0,0,168,281ZM168,278.75ZM168,289.025Z" transform="translate(-160 -275)"/></svg>
)
const ClockIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><path d="M90.94,187.86l.9-.9-3.18-3.2v-4.02h-1.2v4.5ZM88,192a7.741,7.741,0,0,1-3.1-.63,8.06,8.06,0,0,1-4.27-4.27,7.942,7.942,0,0,1,0-6.2,8.06,8.06,0,0,1,4.27-4.27,7.942,7.942,0,0,1,6.2,0,8.06,8.06,0,0,1,4.27,4.27,7.942,7.942,0,0,1,0,6.2,8.06,8.06,0,0,1-4.27,4.27A7.741,7.741,0,0,1,88,192ZM88,184Zm0,6.8a6.829,6.829,0,1,0-4.8-2A6.546,6.546,0,0,0,88,190.8Z" transform="translate(-80 -176)"/></svg>
)
const OnlineIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="12.8" viewBox="0 0 16 12.8"><path d="M81.2,268.8a1.23,1.23,0,0,1-1.2-1.2V257.2a1.23,1.23,0,0,1,1.2-1.2H91.6a1.23,1.23,0,0,1,1.2,1.2v4.3l3.2-3.2v8.2l-3.2-3.2v4.3a1.23,1.23,0,0,1-1.2,1.2Zm0-1.2H91.6V257.2H81.2Zm0,0v0Z" transform="translate(-80 -256)"/></svg>
)
const CalendarIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14.4" height="16" viewBox="0 0 14.4 16"><path d="M121.2,192a1.23,1.23,0,0,1-1.2-1.2V178.4a1.23,1.23,0,0,1,1.2-1.2h1.3V176h1.3v1.2h6.8V176h1.3v1.2h1.3a1.23,1.23,0,0,1,1.2,1.2v12.4a1.23,1.23,0,0,1-1.2,1.2Zm0-1.2h12v-8.6h-12Zm0-9.8h12v-2.6h-12Zm0,0v0Zm6,4.6a.786.786,0,1,1,.57-.23A.774.774,0,0,1,127.2,185.6Zm-3.2,0a.786.786,0,1,1,.57-.23A.774.774,0,0,1,124,185.6Zm6.4,0a.786.786,0,1,1,.57-.23A.774.774,0,0,1,130.4,185.6Zm-3.2,3.2a.786.786,0,1,1,.57-.23A.774.774,0,0,1,127.2,188.8Zm-3.2,0a.786.786,0,1,1,.57-.23A.774.774,0,0,1,124,188.8Zm6.4,0a.786.786,0,1,1,.57-.23A.774.774,0,0,1,130.4,188.8Z" transform="translate(-120 -176)"/></svg>
)

const NextCourseBanner = ({ nextOpenCourse }) => (
  <div className="banner">
    <div className="title">
      <span className="icon"><CalendarIcon/></span>
      <span className="name">Próximo curso</span>
    </div>
    <div className="info">
      <span className="date">{nextOpenCourse}</span>
      <span className="group">Grupo abierto</span>
    </div>
    <div className="bottom">
      <span>* Este curso se impartirá al tener una demanda de al menos 5 personas</span>
    </div>
  </div>
)

const CourseTemplate = ({ data }) => {
  const { frontmatter, html } = data.markdownRemark
  const { course, title, duration, profile, nextOpenCourse } = frontmatter

  return (
    <>
      <NavigationBar activePage="courses" />
      <section id="course-detail">
        <div className="content navigationbar-space">
          <div className="course">
            <div className="text">
              <div className="head">
                <Link to={`/courses/${course.toLowerCase().replace(' ', '-')}`}>
                  <span className="back-button">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14.25" height="22.828" viewBox="0 0 14.25 22.828">
                      <path d="M17501.492-284.62l-10,9.883,10,10.117" transform="translate(-17488.664 286.042)" />
                    </svg>
                    <span>Regresar a Cursos de {course}</span>
                  </span>
                </Link>
                <h1 className="title">{title}</h1>
                <div className="tags">
                  { profile ? <span className="tag"><ProfileIcon /> {profile}</span> : null}
                  { duration ? <span className="tag"><ClockIcon /> {duration} {(duration > 1) ? "Días" : "Día"}</span> : null}
                  <span className="tag"><OnlineIcon /> Online</span>
                </div>
              </div>
              { nextOpenCourse ? <NextCourseBanner nextOpenCourse={nextOpenCourse} /> : null }
              <div className="description">
                <div dangerouslySetInnerHTML={{ __html: html }} />
              </div>
            </div>
            <div className="contact">
              <h2 className="title">Regístrate</h2>
              <div className="card">
                <CourseForm path={course} course={title} />
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
      <CookiesModal />
    </>
  )
}

export default CourseTemplate

export const Head = ({ data, location }) => {
  const { frontmatter } = data.markdownRemark
  const { title, description } = frontmatter
  const { pathname } = location

  return <Seo title={title} description={description} pathname={pathname}/>
}

export const query = graphql`
  query CourseTemplateQuery($pagePath: String) {
    markdownRemark(frontmatter: {path: {eq: $pagePath}}) {
      html
      frontmatter {
        path
        course
        title
        duration
        profile
        description
      }
    }
  }
`